import { PostData } from '../types';
import { MediaType } from '../../../../../models/graphql';

export const videoUnder3Sec = (data: PostData) => {
  return (
    data.publishingMethod === 'DIRECT' &&
    data.media?.type === MediaType.VIDEO &&
    data.media?.videoLength &&
    data.media?.videoLength < 3
  );
};
